import { Component, OnInit } from '@angular/core';
import { CommonConstant } from '../../utilities/common-constant';
import { environment } from 'src/environments/environment';
import { StorageHandlerService } from '../../services/storage-handler.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public bajajMarketsLogo = environment.serviceBaseUrls.AEMURL + CommonConstant.AEMURLs.CompanyLogoImageUrl;
  public showFinvuLogo:boolean = true
  constructor() { }

  ngOnInit(): void {
  }

}
